module.exports = __webpack_public_path__ + "static/DSC_9385-b4b231b95d805b114fde32a4d50a6c3e.jpg";